import styled from "styled-components";
import { BodyCardCheck, ContainerCardCheck } from "../CardCheck/localStyle";

export const ContainerCardAusente = styled(ContainerCardCheck)``;

export const ContainerTopCardAusente = styled.div`
  height: 45px;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background: var(--color-grey-greadient);
  h1 {
    margin: 0;
    padding: 0;
    padding-right: 10px;
    font-size: 18px;
    color: var(--color-white);
  }
`;

export const BodyCardAusente = styled(BodyCardCheck)`
    .ausente {
        /* margin: auto; */
        display: flex;
        align-self: center;
        font-size: 18px;
        color: var(  --color-grey45);
        text-transform: capitalize;
        font-weight: 700;
    }
`;
